import { FormControl, Tabs, Tab } from "@mui/material";
import _ from "lodash";

const defaultOptions = [
  { label: "Vademecum", value: "vademecum" },
  { label: "Manual", value: "manual" },
];

const MethodPicker = ({
  method,
  setMethod,
  options = defaultOptions,
  handleChangeTabs,
  ...props
}) => {
  return (
    <FormControl {...props}>
      <Tabs
        value={method}
        onChange={handleChangeTabs}
        indicatorColor="none"
        textColor="primary"
        variant="fullWidth"
        sx={{
          background: "#F1F5F9",
          borderRadius: 3,
          p: 1,
          minHeight: "34px",
          height: "34px",
        }}
      >
        {_.map(options, ({ label, value, disabled }, i) => (
          <Tab
            key={i}
            value={value}
            label={label}
            disabled={disabled}
            sx={{
              fontSize: { xs: 12, sm: 14 },
              p: 0,
              textTransform: "none",
              minHeight: "34px",
              height: "34px",
              "&.Mui-selected": { background: "white", borderRadius: 3 },
            }}
          />
        ))}
      </Tabs>
    </FormControl>
  );
};

export default MethodPicker;
